import Store from "App/Store.js";

const dCheckoutOrderVouchers = checkoutOrderVouchers => Store.dispatch({type: "checkoutOrderVouchers", checkoutOrderVouchers});

export default dCheckoutOrderVouchers;
